<template>
    <section  class="skills-section d-flex flex-column justify-content-space-around fade-out-element align-items-center">
        <h1 class="inter-500 linear-gradient-black-to-green-2 text-1">Herramientas y Habilidades</h1>
        <BaseList :list-items="habilites" />
        <BaseList :list-items="tools1" />
        <BaseList :list-items="tools2" />
        <div class="icons-container justify-content-space-around">
            <figure class="btn-animated brand-text">
                <img src="../assets/angular_gradient.svg" alt="Angular">
            </figure>
            
            <figure class="btn-animated">
                <img src="../assets/js_logo.svg" alt="JavaScript">
            </figure>
            <figure class="btn-animated">
                <img src="../assets/my_sql.svg" alt="MySQL">
            </figure>
            <figure class="btn-animated">
                <img src="../assets/css3.svg" alt="CSS3">
            </figure>
            <figure class="btn-animated">
                <img src="../assets/html5.svg" alt="HTML5">
            </figure>
            <figure class="btn-animated">
                <img src="../assets/bootstrap_5_logo.svg" alt="Bootstrap 5">
            </figure>
        </div>
    </section>
</template>

<script setup lang="ts">
import BaseList from './BaseList.vue';

const habilites: string[] = [
    'trabajo en equipo',
    'responsable',
    'rapido aprendizaje',
    'iniciativa y compromiso',
]

const tools1: string[] = [
    'GIT',
    'HTML5',
    'CSS3',
    'JavaScript',
    'VueJs',
    'Angular',
]

const tools2: string[] = [
    'MySQL',
    'Bootstrap 5',
    'COBOL74',
    'DASDL',
    'Web Enabler',
    'ClearPath MCP',
]


</script>

<style lang="css" scoped>
.skills-section {
    gap: 2em;
    flex-wrap: wrap;
    width: 100%;
    margin: auto;
    margin-top: 2em;
    font-size: 0.8em;
    flex-direction: column;
}

h1 {
    width: 100%;
    text-align: center;
}

.icons-container {
    width: 85%;
    display: flex;
    gap: 1em;
}
figure {
    width: 3.5em;
    height: 3.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5em;
}
img {
    width: 85%;
    height: 85%;
    object-fit: contain;
}
.btn-animated {
    animation: transformBtn linear forwards;
    animation-timeline: scroll();
    transition: all 100ms cubic-bezier(0.075, 0.82, 0.165, 1);
    border-radius: 50%;
    padding: 0.3rem;
}

.icons-container .btn-animated:nth-child(1) {
    animation-range: entry 20% cover 25%;
}
.icons-container .btn-animated:nth-child(2) {
    animation-range: entry 25% cover 30%;
}
.icons-container .btn-animated:nth-child(3) {
    animation-range: entry 30% cover 35%;
}
.icons-container .btn-animated:nth-child(4) {
    animation-range: entry 35% cover 40%;
}
.icons-container .btn-animated:nth-child(5) {
    animation-range: entry 40% cover 45%;
}
.icons-container .btn-animated:nth-child(6) {
    animation-range: entry 45% cover 50%;
}

@media (min-width: 576px) {
    .skills-section {
        width: 70%;
        flex-direction: row;
    }
    figure{
       width: 5.53em;
        height: 5.53em;
    }
    .icons-container .btn-animated:nth-child(1) {
        animation-range: entry 0% cover 10%;
    }
    .icons-container .btn-animated:nth-child(2) {
        animation-range: entry 5% cover 15%;
    }
    .icons-container .btn-animated:nth-child(3) {
        animation-range: entry 10% cover 20%;
    }
    .icons-container .btn-animated:nth-child(4) {
        animation-range: entry 15% cover 25%;
    }
    .icons-container .btn-animated:nth-child(5) {
        animation-range: entry 20% cover 30%;
    }
    .icons-container .btn-animated:nth-child(6) {
        animation-range: entry 25% cover 35%;
    }
}

@keyframes transformBtn {
        from {
                transform: scale(1);
                background-color: transparent
            }

            to {
                transform: scale(1.1) rotateY(360deg);
                box-shadow: 0 0 4px rgba(185, 185, 185, 0.92);
                background-color: var(--main-bg-color-dark);
            }
        }
</style>